import React from "react";
import SearchFilterCheckboxNumber from "./SearchFilterCheckboxNumber";
import AlterationForm from "../../model/AlterationForm";

interface ISearchFilterCheckboxNumberGroupProps {
  name: string;
  onChange: (
    inputID: string,
    newValue: string | boolean | Set<number> | Set<string>
  ) => void;
  data: AlterationForm;
  selected: Set<number>;
}

function SearchFilterCheckboxNumberGroup({
  name,
  onChange,
  data,
  selected,
}: ISearchFilterCheckboxNumberGroupProps) {
  const toggleAll = (checked: boolean) => {
    if (checked) {
      data.alterations!.map((item) => selected.add(item.id!));
    } else {
      selected.clear();
    }
    onChange(name, selected);
  };

  let allSelected = true;
  for (let i = 0; i < data.alterations!.length && allSelected; i++) {
    if (!selected.has(data.alterations![i].id!)) {
      allSelected = false;
    }
  }

  return (
    <div className="checkbox-group">
      <div key={name + "_" + data.id} className="checkbox-group-name">
        <input
          type="checkbox"
          id={name + "_" + data.id}
          name={name + "_" + data.id}
          checked={allSelected}
          onClick={(e) => toggleAll(e.currentTarget.checked)}
          onChange={() => {}}
        />
        <label>{data.name}</label>
      </div>
      <div className="checkbox-filter">
        <SearchFilterCheckboxNumber
          name={name}
          onChange={onChange}
          data={data.alterations!}
          selected={selected}
        />
      </div>
    </div>
  );
}

export default SearchFilterCheckboxNumberGroup;
